import { render, staticRenderFns } from "./TaskSidebar.vue?vue&type=template&id=5f2d806c&scoped=true&"
import script from "./TaskSidebar.vue?vue&type=script&setup=true&lang=js&"
export * from "./TaskSidebar.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TaskSidebar.vue?vue&type=style&index=0&id=5f2d806c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2d806c",
  null
  
)

export default component.exports